module.exports = {
  contentfulToInternal(asset) {
    const result = {
      id: asset.sys.id,
      published: Boolean(asset.sys.publishedVersion),
      updated: asset.sys.publishedVersion && asset.sys.version > asset.sys.publishedVersion + 1,
      draft: !asset.sys.publishedVersion,
      archived: Boolean(asset.sys.archivedVersion),
      createdAt: new Date(asset.sys.createdAt),
      updatedAt: new Date(asset.sys.updatedAt),

      title: '',
      description: '',
      contentType: asset.fields.file['nb-NO'].contentType,
      fileName: asset.fields.file['nb-NO'].fileName,
      details: {
        size: asset.fields.file['nb-NO'].details.size
      },
      url: asset.fields.file['nb-NO'].url,
      tags: asset.metadata.tags && asset.metadata.tags.length > 0 ? asset.metadata.tags.map((tag) => tag.sys) : []
    };

    if (asset.fields.title && asset.fields.title['nb-NO']) {
      result.title = asset.fields.title['nb-NO'];
    }

    if (asset.fields.description && asset.fields.description['nb-NO']) {
      result.description = asset.fields.description['nb-NO'];
    }

    if (asset.fields.file['nb-NO'].details.image) {
      result.details.image = {
        height: asset.fields.file['nb-NO'].details.image.height,
        width: asset.fields.file['nb-NO'].details.image.width
      };
    }

    return result;
  },

  internalToContentful(asset) {
    const result = {
      fields: {},
      metadata: {
        tags: []
      }
    };

    if (asset.title !== undefined) {
      result.fields.title = {
        'nb-NO': asset.title
      };
    }

    if (asset.description !== undefined) {
      result.fields.description = {
        'nb-NO': asset.description
      };
    }

    if (asset.tags.length > 0) {
      result.metadata.tags = asset.tags.map((tag) => {
        return {
          sys: {
            id: tag.id,
            linkType: 'Tag',
            type: 'Link'
          }
        };
      });
    }

    return result;
  }
};
